import React from 'react';
import fLogo from '../../images/footer/f_logo.png';
import iconAws from '../../images/footer/icon_aws.png';
import iconNipa from '../../images/footer/icon_nipa.png';
export default function Footer() {
    return (
        <div id="footer">
            <div className="container">
                <div>
                    <div>
                        <a href="http://www.playauto.co.kr/download/PLAYAUTO_20201Q.pdf" target="blank">
                            회사소개
                        </a>
                        <a href="https://plto.com/policy/CommonPolicy/?tabIndex=0" target="blank">
                            이용약관
                        </a>
                        <a href="https://plto.com/policy/CommonPolicy/?tabIndex=2" className="c-primary" target="blank">
                            개인정보처리방침
                        </a>
                    </div>
                </div>
                <div>
                    <div>
                        <p>
                            (주)커넥트웨이브 대표: 김정남<span> | </span>개인정보 보호책임자: 백승준<span> | </span>
                            주소: 서울특별시 금천구 벚꽃로 298, 17층 (가산동, 대륭포스트타워6차)
                        </p>
                        <p>
                            사업자번호: 117-81-40065<span> | </span>통신판매 신고번호: 제2004-서울양천-00918호
                            <a
                                href="https://www.ftc.go.kr/bizCommPop.do?wrkr_no=1178140065"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ marginLeft: '5px' }}
                            >
                                사업자정보확인
                            </a>
                        </p>
                        <p>
                            이메일주소 : <a href="mailto:playapi@playauto.co.kr">playapi@playauto.co.kr</a>
                        </p>
                    </div>
                </div>
                <div>
                    <p className="left">
                        <img alt="" src={fLogo} />
                    </p>
                    <p className="right">
                        <img alt="" src={iconAws} />
                        <img alt="" src={iconNipa} />
                    </p>
                </div>
            </div>
        </div>
    );
}
